import { conditionTypesSlice } from "./conditionTypesSlice";
import * as defaultActions from "../../../../../redux/_common";

const { actions } = conditionTypesSlice;
const moduleUrl = '/api/pricing/pricingConditions/conditionType'

export const setValidationErrors = actions.setValidationErrors;

export const getDropDownItems = (params: {}) => defaultActions.getDropDownItems(`${moduleUrl}/select`, actions, params);